import * as React from 'react';

export interface IErrorProps {
    errorText: string;
    onDismiss: () => void;
}

export function SearchError({ errorText, onDismiss }: IErrorProps) {
    return (
        <div className="adage-search-alert adage-search-alert-error" role="dialog">
            <div className="adage-search-alert-content">
                <div className="adage-search-alert-content-text" dangerouslySetInnerHTML={{ __html: errorText }} />
            </div>

            <button className="adage-search-alert-close" onClick={onDismiss}>
                Dismiss
            </button>
        </div>
    );
};
